import { GatedNavLink } from "./GatedLink";

import { useAuth } from "../../js/hooks/useAuth";

import { hasClientAccess } from "../../js/auth/authService";

import { useNotifications } from "../../js/hooks/useNotifications";

import { useStore } from "../../js/state/store";

import NavUnread from "../messaging/NavUnread";

import { toTitleCase } from "../../js/utils/titleCase";

import ResourcesLink from "../layout/ResourcesLink";

import { manualsUrl, pricingUrl, JOURNEY_LINK_PROPS } from "../../js/utils/siteLinks";

import { clientMessagesPath, primaryNavLinks } from "../../js/navigation/roleNav";



function NavItem({ link }) {

  if (link.href) {

    return (

      <a href={link.href} className="nav-link" {...JOURNEY_LINK_PROPS}>

        {toTitleCase(link.label)}

      </a>

    );

  }

  return (

    <GatedNavLink

      to={link.to}

      allow={link.allow}

      className={({ isActive }) => `nav-link${isActive ? " is-active" : ""}`}

    >

      {toTitleCase(link.label)}

      <NavUnread count={link.unread} />

    </GatedNavLink>

  );

}



export default function TopNav() {

  const { role, session } = useAuth();

  const { messageUnread } = useNotifications();

  const { dispatch } = useStore();



  const links = primaryNavLinks(session);

  const extras = [];



  if (role && hasClientAccess(role) && role !== "admin" && !links.some((item) => item.to === "/client/messages")) {

    extras.push({

      to: clientMessagesPath(role),

      label: "Messages",

      allow: true,

      unread: messageUnread,

    });

  }

  if (role === "buyer") {

    extras.push({ href: manualsUrl("buyer", session), label: "User Guide" });

  }

  if (role === "seller") {

    extras.push({ href: manualsUrl("seller", session), label: "User Guide" });

  }

  if (role === "agent") {

    extras.push({ href: manualsUrl("agent", session), label: "User Guide" });

  }

  if (role === "broker" || role === "corporate") {

    extras.push({ href: manualsUrl("broker", session), label: "User Guide" });

  }

  if (role === "admin") {

    extras.push({ href: manualsUrl(undefined, session), label: "Journey Manuals" });

  }



  return (

    <nav className="top-nav main-nav" aria-label="Primary">

      {links.map((link) => (

        <NavItem key={`${link.label}-${link.to || link.href}`} link={link} />

      ))}

      {!role || role === "buyer" || role === "seller" ? (

        <button

          type="button"

          className="nav-link"

          onClick={() => {

            dispatch({ type: "SET_SIDEBAR", payload: false });

            dispatch({ type: "OPEN_MODAL", payload: "clientAccess" });

          }}

        >

          Client Access

        </button>

      ) : null}

      <ResourcesLink className="nav-link" tour="nav-resources-main" label="Resources" />

      {!role || role === "buyer" || role === "seller" ? (

        <button

          type="button"

          className="nav-link nav-link--install"

          aria-label="Add to Home Screen"

          title="Add to Home Screen"

          onClick={() => dispatch({ type: "OPEN_MODAL", payload: "install" })}

        >

          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">

            <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />

            <line x1="12" y1="18" x2="12.01" y2="18" />

          </svg>

        </button>

      ) : null}

      {extras.length ? (

        <div className="main-nav__extras" aria-label="Signed-in menu">

          {extras.map((link) => (

            <NavItem key={link.label} link={link} />

          ))}

        </div>

      ) : null}

      {!session ? (

        <a

          href={pricingUrl()}

          className="nav-link nav-link--get-started"

          data-tour="nav-get-started"

          {...JOURNEY_LINK_PROPS}

        >

          Get Started Today!

        </a>

      ) : null}

    </nav>

  );

}


